import React, { useState } from "react";
import { Form, Button } from "react-bootstrap";
import axios from "axios";
import { API_BASE_URL } from '../config/api';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import axiosClient from "../api/axiosClient";
import Alert from "./Alert";
import { useLanguage } from "../contexts/LanguageContext";

const ToolsCollab = () => {
  const L = useLanguage();
  const [spyUsername, setSpyUsername] = useState('');
  const [spyLoading, setSpyLoading] = useState(false);
  const [competitorsAnalyzed, setCompetitorsAnalyzed] = useState(0);
  const [competitors, setCompetitors] = useState([]);
  const [functionError, setFunctionError] = useState("");
  const [functionSuccess, setFunctionSuccess] = useState("");

  const fetchCompetitors = async () => {
    if (!spyUsername) {
      alert(L.toolsCollab.enterUsername);
      return;
    }
    
    setSpyLoading(true);
    setCompetitorsAnalyzed(0);

    const counterInterval = setInterval(() => {
      const volatility = Math.random();
      const increment = volatility > 0.8 
        ? Math.floor(Math.random() * 500 + 200)
        : Math.floor(Math.random() * 15 + 5);  
      
      setCompetitorsAnalyzed(prev => prev + increment);
    }, Math.floor(Math.random() * 200 + 50));

    try {
      const response = await axiosClient.post("https://api.viralgpt.com/spy", {
        username: spyUsername
      });
      setCompetitors(response.data.competitors);
      setFunctionSuccess(L.toolsCollab.success(response.data.competitors.length));
    } catch (error) {
      setFunctionError(error.response?.data?.error || L.toolsCollab.fetchFailed);
    } finally {
      clearInterval(counterInterval);
      setSpyLoading(false);
      setCompetitorsAnalyzed(0);
    }
  };

  return (
    <div className="bg-white border p-6">
      <h5>{L.toolsCollab.heading}</h5>
      <p className="text-muted">{L.toolsCollab.subtitle}</p>

      <Alert 
        variant="danger" 
        message={functionError} 
        show={!!functionError} 
        onClose={() => setFunctionError("")} 
      />
      
      <Alert 
        variant="success" 
        message={functionSuccess} 
        show={!!functionSuccess} 
        onClose={() => setFunctionSuccess("")} 
      />
      
      <div className="d-flex gap-2 mb-4">
        <Form.Control
          type="text"
          placeholder={L.toolsCollab.usernamePlaceholder}
          value={spyUsername}
          onChange={(e) => setSpyUsername(e.target.value)}
          style={{ maxWidth: '250px' }}
        />
        <Button 
          className={spyLoading ? "disabled bg-instagram" : "bg-instagram"}
          onClick={fetchCompetitors}
        >
          {spyLoading 
            ? L.toolsCollab.analyzing(competitorsAnalyzed.toLocaleString()) 
            : L.toolsCollab.analyze}
        </Button>
        <div 
          style={{fontSize: "1.5rem", display: "flex", alignItems: "center"}} 
          className={`ms-2 fa fa-circle-notch fa-spin text-instagram ${!spyLoading ? "d-none" : ""}`}
        />
      </div>
      <div className="row">
        {competitors.map((competitor, index) => (
          <div key={index} className="col-md-4 mb-4">
            <a 
              href={`https://instagram.com/${competitor.username}`}
              target="_blank"
              rel="noopener noreferrer"
              style={{ textDecoration: 'none', color: 'inherit' }}
            >
              <div className="border rounded p-3 hover-shadow" style={{ 
                transition: 'all 0.2s ease-in-out',
                cursor: 'pointer'
              }}>
                <div className="d-flex align-items-center mb-3">
                  <img 
                    src={`https://rizzup.net/proxy/${encodeURIComponent(competitor.profile_pic_url)}`} 
                    alt={competitor.username}
                    className="rounded-circle"
                    style={{ width: "50px", height: "50px", objectFit: "cover" }}
                    onError={(e) => { e.target.onerror = null; e.target.src = '/images/default.png'; }}
                  />
                  <div className="ms-3">
                    <h6 className="mb-0 d-flex align-items-center">
                      {competitor.username}
                      {competitor.is_verified && 
                        <i className="fas fa-check-circle text-primary ms-1" style={{fontSize: "14px"}}/>
                      }
                      <OverlayTrigger
                        placement="top"
                        overlay={
                          <Tooltip>
                            {L.toolsCollab.similarityTooltip}
                          </Tooltip>
                        }
                      >
                        <span className="ms-2 badge bg-instagram" style={{cursor: 'help'}}>
                          {competitor.similarity_score}%
                        </span>
                      </OverlayTrigger>
                    </h6>
                    <small className="text-muted">{competitor.full_name}</small>
                  </div>
                </div>
                <p className="text-muted small mb-0" style={{
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  display: "-webkit-box",
                  WebkitLineClamp: "2",
                  WebkitBoxOrient: "vertical"
                }}>
                  {competitor.biography}
                </p>
              </div>
            </a>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ToolsCollab;